import { render } from "./overview.vue?vue&type=template&id=1f5508cc&scoped=true&ts=true"
import script from "./overview.vue?vue&type=script&lang=ts"
export * from "./overview.vue?vue&type=script&lang=ts"

import "./overview.vue?vue&type=style&index=0&id=1f5508cc&scoped=true&lang=less"

import exportComponent from "/home/runner/work/vue3-admin/vue3-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f5508cc"]])

export default __exports__